<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="title-h3">스크립트 수행 이력</div>
    <div>
      <el-button size="small" @click="exportScriptInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper :data="dataList" :columns="histColumns" ref="scriptInfoTable"
  :show-custom-header="true" :show-search-tool="showSearchTool"
  :total="total" :column-default="columnDefault" remote pagination @condition-change="onTableConditionChange">
    <template #status-slot="scope">
      <span v-if="scope.row.jobStatus === '1'" class="state-normal">성공</span>
      <span v-else class="state-abnormal">실패</span>
    </template>
    <template #type-slot="scope">
      <span v-if="scope.row.jobType === 'S'">스케줄</span>
      <span v-else>수동실행</span>
    </template>
    <template #detail-info="scope">
      <span v-if="getDetailIcon(scope.row)" @click="showScriptResult(scope.row)"><i class="fas fa-search-plus c-pointer"></i></span>
      <span v-else> {{getEmptyText()}}</span>
    </template>
  </el-table-wrapper>
  <w-script-execute-detail-show-popup ref="scriptExecuteSlidingPopup" :popupParams="popupParams" />
</div>
</template>

<script>
import { isEmpty, isNil } from 'lodash';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import WScriptExecuteDetailShowPopup from '@/views/config/node/netdevice/components/ScriptExecuteDetailShowPopup';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { mapGetters } from 'vuex';
import { columnDefault } from '@/constants/table';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';

export default {
  name: 'WScriptExecuteHistNode',
  components: {
    WScriptExecuteDetailShowPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
    nodeParams: {
      type: Object,
    },
  },
  computed: mapGetters(['selectedNode']),
  data() {
    return {
      columnDefault,
      total: null,
      popupParams: {},
      showSearchTool: false,
      dataList: null,
      params: {
        objId: null,
      },
      histColumns: [
        {
          prop: 'jobStatus',
          width: 100,
          label: '상태',
          sortable: true,
          remoteProp: 'JHD.job_status',
          scopedSlot: 'status-slot',
          filters: [
            {
              text: '성공',
              value: '1',
            },
            {
              text: '실패',
              value: '0',
            },
          ],
        },
        {
          prop: 'jobName',
          label: '작업명',
          remoteProp: 'JH.job_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objName',
          label: '장비명',
          remoteProp: 'O.obj_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipaddress',
          label: 'IP',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'jobType',
          label: '작업구분',
          remoteProp: 'JH.job_type',
          sortable: true,
          scopedSlot: 'type-slot',
          filters: [
            {
              text: '스케줄',
              value: 'S',
            },
            {
              text: '수동실행',
              value: 'M',
            },
          ],
        },
        {
          prop: 'managerName',
          label: '작업자',
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'checkDatetime',
          label: '작업일시',
          remoteProp: 'JH.check_datetime',
          sortable: true,
          searchable: true,
          searchType: 'date',
          formatter: this.convertDatetime,
        },
        {
          prop: 'jobResult',
          width: 90,
          label: '상세보기',
          scopedSlot: 'detail-info',
          align: 'center',
          searchable: false,
          sortable: true,
        },
      ],
    };
  },
  watch: {
    activeTab: {
      handler() {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadStore();
      },
    },
    selectedNode: {
      handler(node) {
        if (isEmpty(node)) {
          return;
        }
        this.params.objId = this.selectedNode.obj.objId;
        this.loadStore();
      },
      immediate: true,
    },
  },
  methods: {
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    loadStore() {
      const me = this;
      if (!isNil(this.params.objId) && this.activeTab === this.$options.name) {
        const tableParams = this.$refs.scriptInfoTable.getParameter();
        const params = {
          ...this.params,
          ...tableParams,
        };
        netdeviceInfoAPI.getWorkHistoryList(params).then((response) => {
          me.dataList = response.data.data;
          me.total = response.data.total;
        });
      }
    },
    getDetailIcon(value) {
      if (!isNil(value.jobResult)) {
        return true;
      }
      return false;
    },
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    showScriptResult(row) {
      if (!isNil(row.jobResult)) {
        this.popupParams = row;
        this.$refs.scriptExecuteSlidingPopup.open();
      }
    },
    exportScriptInfo() {
      if (!isNil(this.params.objId)) {
        const tableParams = this.$refs.scriptInfoTable.getParameter();
        delete tableParams.start;
        delete tableParams.limit;
        const parameters = {
          ...tableParams,
          ...this.params,
        };

        netdeviceInfoAPI.exportScriptInfo(parameters)
          .then((response) => {
            if (response.data.success && !isNil(response.data.data)) {
              FileApi.downloadExportedExcelFile(response.data.data);
            } else {
              this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          });
      }
    },
    onTableConditionChange() {
      this.loadStore();
    },
    getEmptyText() {
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/config/node/netdevice/scriptexecutehist/index.vue